package uz.ferro.shop.helmet

import kotlinx.browser.document
import react.FC
import react.Props
import react.useEffect

external interface HelmetProps : Props {
    var title: String?
    var description: String?
    var keywords: String?
}

val Helmet = FC<HelmetProps> { props ->
    useEffect {
        document.title = props.title.orEmpty()
        document.querySelector("meta[name=\"description\"]")
            ?.setAttribute("content", props.description.orEmpty())

        document.querySelector("meta[name=\"keywords\"]")
            ?.setAttribute("content", props.keywords.orEmpty())
    }
}